import React from 'react';
import { Col, Row } from 'react-bootstrap';

const SummaryRow = ({ label, value, show = true }) => {
  if (!show) {
    return <></>;
  }

  return (
    <Row className="mb-3">
      <Col xs={6} className="text-muted">
        {label}
      </Col>
      <Col xs={6} className="">
        {value}
      </Col>
    </Row>
  );
};

export default SummaryRow;
